export default __webpack_public_path__ + "media/images/icon_tos-bdf2d5ff088b680aa2c3d0f08fa51ea5.png";